import _forOwn from "lodash/forOwn";
import { object, mixed } from "yup";

const businessDocumentsValidation = (documentData, reportableBOCount) => {
  const getFileValidationSchema = () => {
    const fileUploadsSchema = {};
    _forOwn(documentData, ({ name, label, optional = false }) => {
      fileUploadsSchema[name] = mixed().when("$makeFieldsOptional", {
        is: (makeFieldsOptional) =>
          makeFieldsOptional ||
          (name === "formBOF1" ? reportableBOCount === 0 : optional),
        then: mixed().optional(),
        otherwise: mixed().required(`${label} is required`),
      });
    });
    return fileUploadsSchema;
  };

  const schema = object().shape({
    fileUploads: object(getFileValidationSchema()),
  });

  return {
    schema,
    schemaInitialValues: schema.cast(),
  };
};

export default businessDocumentsValidation;
